module.exports = __webpack_public_path__ + "img/6.563fd07f.png";